import React from "react";
import style from "./App.module.css";
import SideBanner from "./components/SideBanner/SideBanner";
import MainContent from "./components/MainContent/MainContent";


const App: React.FC = () => {


  return (
    <div className={style.App}>
      <SideBanner side="left" />
      <MainContent />
      <SideBanner side="right" />
    </div>
  );
};

export default App;
